import { render, staticRenderFns } from "./CrfPreview.vue?vue&type=template&id=d6afb74a&"
import script from "./CrfPreview.vue?vue&type=script&lang=js&"
export * from "./CrfPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports